import router from "@/router";
import Cookies from 'js-cookie';

const privateArea = [
    "/my-mailbox",
];

router.beforeEach(async (to, _, next) => {
    const customer = Cookies.get("mat");

    if (!customer) {
        if (privateArea.includes(to.path)) {
            next("/auth/login");
        } else {
            next();
        }
        return;
    }
    
    if (to.meta.permission) {
        // const { permission } = to.meta as {permission:[string]};
        const hasPermission = false;//await checkPermission(permission);
        if (hasPermission) {
            next();
        } else {
            next("/403");
        }
    } else {
        next();
    }
});